import panelsystemspdf from '../img/panelsystems/RRDS_bullet_resistant_panels_brochure.pdf';

// Function to detect mobile devices (excluding tablets)
const isMobileDevice = () => {
  return /Android|iPhone|iPod|webOS|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent,
  );
};

// Function to handle iframe removal for mobile devices
const removeIframeOnMobile = iframe => {
  if (isMobileDevice() && iframe) {
    iframe.remove();
  }
};

// Function to handle video play and image fallback behavior
const handleVideoPlay = (iframe, fallbackImage, hero) => {
  if (!iframe || !fallbackImage || !hero) return;

  const player = new Vimeo.Player(iframe);
  const panelBtn = document.querySelector('.panel__btn');

  player.on('play', function () {
    fallbackImage.style.display = 'none';
    hero.classList.remove('panel__hero--height');
    panelBtn.classList.add('panel__btn--video');
  });
};

// DOMContentLoaded event to trigger functions once the DOM is fully loaded
document.addEventListener('DOMContentLoaded', function () {
  const iframe = document.querySelector('.panel__hero__video');
  const fallbackImage = document.querySelector('.panel__hero picture img');
  const hero = document.querySelector('.panel__hero');

  removeIframeOnMobile(iframe); // Remove iframe on mobile
  handleVideoPlay(iframe, fallbackImage, hero); // Manage video play and image visibility
});
